import React from 'react';
import { Card } from '../ui/Card';
import { Trophy, Zap, Target, Flame, Star } from 'lucide-react';
interface PersonalRecordsSectionProps {
  fastestTime: number | null;
  accuracy: number;
  longestStreak: number;
  perfectSessions: number;
  dailyGoals: number;
}
export function PersonalRecordsSection({
  fastestTime,
  accuracy,
  longestStreak,
  perfectSessions,
  dailyGoals
}: PersonalRecordsSectionProps) {
  const formatTime = (ms: number) => {
    const seconds = (ms / 1000).toFixed(1);
    return `${seconds}s`;
  };
  const records = [{
    id: 'fastest',
    label: 'Snelste Goede Antwoord',
    value: fastestTime ? formatTime(fastestTime) : '-',
    icon: Zap,
    color: 'text-amber-500',
    bg: 'bg-amber-100',
    border: 'border-amber-200'
  }, {
    id: 'accuracy',
    label: 'Gemiddelde Nauwkeurigheid',
    value: `${accuracy}%`,
    icon: Target,
    color: 'text-blue-500',
    bg: 'bg-blue-100',
    border: 'border-blue-200'
  }, {
    id: 'streak',
    label: 'Langste Reeks',
    value: `${longestStreak} dgn`,
    icon: Flame,
    color: 'text-orange-500',
    bg: 'bg-orange-100',
    border: 'border-orange-200'
  }, {
    id: 'perfect',
    label: 'Perfecte Sessies',
    value: perfectSessions,
    icon: Star,
    color: 'text-purple-500',
    bg: 'bg-purple-100',
    border: 'border-purple-200'
  }, {
    id: 'goals',
    label: 'Dagdoelen Gehaald',
    value: dailyGoals,
    icon: Trophy,
    color: 'text-emerald-500',
    bg: 'bg-emerald-100',
    border: 'border-emerald-200'
  }];
  return <div className="space-y-4" data-id="element-1876">
      <div className="flex items-center gap-3 px-1" data-id="element-1877">
        <div className="w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center" data-id="element-1878">
          <Trophy className="w-5 h-5 text-amber-600" data-id="element-1879" />
        </div>
        <h2 className="text-xl font-black text-slate-800" data-id="element-1880">
          Persoonlijke Records
        </h2>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4" data-id="element-1881">
        {records.map(record => <Card key={record.id} className={`p-4 border-2 ${record.border} bg-white rounded-2xl shadow-sm flex flex-col items-center text-center`} data-id="element-1882">
            <div className={`w-12 h-12 rounded-full ${record.bg} ${record.color} flex items-center justify-center mb-3`} data-id="element-1883">
              <record.icon className="w-6 h-6" data-id="element-1884" />
            </div>
            <div className="text-2xl font-black text-slate-800 mb-1" data-id="element-1885">
              {record.value}
            </div>
            <div className="text-xs font-bold text-slate-500 uppercase tracking-wider leading-tight" data-id="element-1886">
              {record.label}
            </div>
          </Card>)}
      </div>
    </div>;
}